import BadRequestPage from '../components/badRequestPage'
import Home from '../components/homePage'
import Hyjj from '../components/hyjj'
import Ljhd from '../components/ljhd'
import Ltgk from '../components/ltgk'
import Ltsy from '../components/ltsy'
import Qyfc from '../components/qyfc'
import Spbf from '../components/spbf'
import Sqb from '../components/sqb'
import Wzxq from '../components/wzxq'
import Ywzx from '../components/ywzx'
import Zjxc from '../components/zjxc'
import Zjzk from '../components/zjzk'
import Zzjg from '../components/zzjg'
import LjhdList from '../components/ljhdList'

const publicRoute = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/sqb/name/:name',
    element: <Sqb />
  },
  {
    path: '/hyjj/channel_id?/:channel_id?/:page?',
    element: <Hyjj />
  },
  {
    path: '/ywzx/channel_id/:channel_id/:page?',
    element: <Ywzx />
  },
  {
    path: '/ltsy/channel_id/:channel_id/:page?',
    element: <Ltsy />
  },
  {
    path: '/zjxc/channel_id/:channel_id/:page?',
    element: <Zjxc />
  },
  {
    path: '/qyfc/channel_id/:channel_id/:page?',
    element: <Qyfc />
  },
  {
    path: '/ljhd/channel_id/:channel_id/:page?',
    element: <Ljhd />
  },
  {
    path: '/ljList/channel_id/:channel_id/:page?',
    element: <LjhdList />
  },
  {
    path: '/zjzk/channel_id/:channel_id/:page?',
    element: <Zjzk />
  },
  {
    path: '/ltgk/channel_id/:channel_id/:page?',
    element: <Ltgk />
  },
  {
    path: '/wzxq/id/:id',
    element: <Wzxq />
  },
  {
    path: '/zzjg/channel_id/:channel_id/:page?',
    element: <Zzjg />
  },
  {
    path: '/spbf/channel_id/:channel_id',
    element: <Spbf />
  },
  {
    path: '*',
    element: <BadRequestPage />
  },
  {
    path: '500',
    element: <BadRequestPage />
  }
]

export default publicRoute
